import { render } from "./CreateInterimReferral.vue?vue&type=template&id=afa6fde4&ts=true"
import script from "./CreateInterimReferral.ts?vue&type=script&lang=ts&external"
export * from "./CreateInterimReferral.ts?vue&type=script&lang=ts&external"

import "./CreateInterimReferral.scss?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__